export enum UserRole {
  Member = 'member',
  Owner = 'owner',
}
